export default function injectCSS(css) {
  if (!css) {
    return null
  } else {
    //intentionally mangle url calls
    const clean = css.replace(/url\(/g, 'url(')

    const style = document.createElement('style')

    style.appendChild(document.createTextNode(clean))

    document.head!.appendChild(style)

    return style.sheet
  }
}
